import {useEffect, useState} from "react";
import {ProductService} from "@/services/product/ProductService.ts";

const useProductOptions = () => {
    const [productOptions, setProductOptions] = useState<ProductGroupByNameOption[]>([])

    useEffect(() => {
        async function getAll() {
            const res: ProductOption[] | null | undefined = await ProductService.getProductOptions();
            if (res) {
                const data: ProductGroupByNameOption[] = [];
                const productMap = new Map<string, ProductGroupByNameOption>();

                res.forEach((o: ProductOption) => {
                    if (o.productName) {
                        if (!productMap.has(o?.productName)) {
                            productMap.set(o.productName, {
                                productName: o.productName,
                                productCode: o.productCode,
                                version: o.version ? [o.version] : []
                            });
                        } else if (o.version) {
                            productMap.get(o.productName)?.version?.push(o.version);
                        }
                    }
                });

                productMap.forEach((value) => data.push(value));
                setProductOptions(data);
            } else {
                setProductOptions([]);
            }
        }

        getAll().then();
    }, [])

    return productOptions;
}

export default useProductOptions;